import { AuthActions } from 'src/app/component/auth/state/action-types';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { isLoggedIn, isLoggedOut } from '../auth/state/auth.selectors';
import { Observable } from 'rxjs/internal/Observable';
import { BehaviorSubject, distinctUntilChanged, map, of, switchMap, take, tap } from 'rxjs';
import { login, removeOtherSessions, tokenLogin } from '../auth/state/auth.actions';
import { MediaMatcher } from '@angular/cdk/layout';
import { RegionService } from '../common-components/region/service/region.service';
import { BaseLocalStorageService } from 'src/app/service/base-local-storage.service';
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { AccessService } from './service/access.service';
import { MatSidenav } from '@angular/material/sidenav';
import { CdkAccordion } from '@angular/cdk/accordion';
import { LoginTokenService } from 'src/app/service/login-token.service';
import { Msg, User, UserToken } from '../auth/model/user.model';

import moment from 'moment';
import { FeatureEntityService } from './service/feature-entity.service';
import { Subscription } from 'rxjs';
import { v4 as uuidv4 } from 'uuid'; // needed for NoSQL
import { HttpClient, HttpEvent } from '@angular/common/http';
import { UrlProviderService } from 'src/app/service/urlprovider.service';
import { HelperService } from 'src/app/service/helper.service';
import { MsinInterceptorService } from 'src/app/service/msin-interceptor.service';
import { AuthService } from '../auth/service/auth.service';
import { WorkflowsService } from '../system/workflows/service/workflows.service';
import { AuthEffects } from '../auth/state/auth.effects';
import { Route } from 'src/app/model/session-tracking/tracking-type';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {
    mobileQuery: MediaQueryList;
    title = 'msin';
    public showMenu: boolean[] = [];
    public showWholeMenu: boolean = false;
    userToken: UserToken | null = null; // Initialize as null by default

    searchCriterias: any = [{}];
    shoppingCarts: any = [{}];
    isLoggedIn$: Observable<boolean> | undefined;
    isLoggedOut$: Observable<boolean> | undefined;
    routeUrl: string = '';
    curRoute: string = '';
    loading = true;
    loadedBackupParams$: Observable<boolean>;
    loadedBackupScreen$: Observable<boolean>;
    subs: Subscription[] = [];

    loadedRoutingsId: string = '';
    sessionTrackerShellIndex: string = '';
    currentUserActivityId: number = 0;
    backupScreenIds: number[] = [];
    loggedInUserName: string = '';
    iPrintOnce: number = 0;
    private _mobileQueryListener: () => void;

    baseLocalStorageService: any;
    localStorageInfo$: Observable<any> = new Observable();
    checkedList: boolean[] = [];
    bDisableFeatureCheck: boolean = true;

    userId = '';
    isUILoggedOut: boolean = true;
    lastPing?: Date;
    authToken: any = null;
    private getBackupDataSubject = new BehaviorSubject<void>(undefined);
    currentRoute: string;
    @ViewChild('sidenav') sidenav: MatSidenav;
    logoutCount: number = 0;
    inboxNodesCount: number = 0;
    inProgressNodesCount: number = 0;
    outboxNodesCount: number = 0;
    private idleTimedoutSub: Subscription; // to communicate this property to navigation so that multi-routes work as well as the basic timeout
    private g_localTimeout: boolean = false;

    constructor(
        private router: Router,
        private store: Store<AppState>,
        private regionService: RegionService,
        changeDetectorRef: ChangeDetectorRef,
        media: MediaMatcher,
        _baseLocalStorageService: BaseLocalStorageService,
        public accessService: AccessService,
        private loginTokenService: LoginTokenService,
        private authService: AuthService,
        private helperService: HelperService,
        private featureEntityService: FeatureEntityService,
        private http: HttpClient,
        private urlProvider: UrlProviderService,
        private msinInterceptorService: MsinInterceptorService,
        private workflowsService: WorkflowsService,
        private authEffects: AuthEffects
    ) {
        //workbench/queued
        this.mobileQuery = media.matchMedia('(max-width: 600px)');
        this._mobileQueryListener = () => changeDetectorRef.detectChanges();
        this.mobileQuery.addListener(this._mobileQueryListener);

        // prep localStorage
        this.baseLocalStorageService = _baseLocalStorageService;
        this.localStorageInfo$ = _baseLocalStorageService.myData$;

        this.logoutCount = 0;
    }

    ngOnInit() {
        console.log('showWholeMenu was:');
        console.log(this.showWholeMenu);
        if (!this.showWholeMenu) {
            const currentRoute = this.router.url;
            console.log('currentRoute is');
            console.log(currentRoute);

            this.showWholeMenu = true;
        }

        // this.router.events.subscribe((event) => {
        //     switch (true) {
        //         case event instanceof NavigationStart: {
        //             this.loading = true;
        //             break;
        //         }
        //         case event instanceof NavigationEnd: {
        //             const currentUrl = event.urlAfterRedirects || event.url;
        //             console.log('initial nav curURL:', currentUrl);
        //             if (
        //                 currentUrl === '/children/search' ||
        //                 currentUrl === '/login'
        //             ) // exclude initial route on login otherwise it will overwrite routes from nosql
        //             {
        //                 this.loading = false;
        //                 break;
        //             } else {
        //                 console.log('visited new screen', currentUrl);

        //             }

        //             this.loading = false;

        //             break;
        //         }
        //         case event instanceof NavigationCancel:
        //         case event instanceof NavigationError: {
        //             this.loading = false;
        //             break;
        //         }
        //         default: {
        //             break;
        //         }
        //     }
        // });

        this.isLoggedIn$ = this.authEffects.isLoggedIn$;
        this.isLoggedOut$ = this.store.pipe(select(isLoggedOut));

        this.authEffects.loggedInUserName$.subscribe((loggedInUserName) => {
            this.loggedInUserName = loggedInUserName;
        });

        this.authEffects.isLoggedIn$.pipe(distinctUntilChanged()).subscribe((x: boolean) => {
            if (x) {
                // console.log('recognizing user as logged in');
                this.showWholeMenu = true;
                if (window.innerWidth >= 768) {
                    setTimeout(() => {
                        this.showWholeMenu = true;
                        if (this.sidenav) {
                            this.sidenav.open();
                        }
                    }, 500);
                } else {
                    setTimeout(() => {
                        console.error('User token not found in localStorage.');

                        this.showWholeMenu = false;
                        try {
                            this.sidenav.close();
                        } catch (Err2) {}
                    }, 500);
                }

                const userToken = localStorage.getItem('userToken');
                //console.log('userToken:');
                //console.log(userToken);
                if (userToken) {
                    // set browser tabbed storage for handling multiple sessions
                    console.log('Multiple sessionhandling, setting token');
                    localStorage.setItem('userToken', userToken);
                    (window as any).dispatchEvent(new Event('storageEvent'));

                    // let objUser = JSON.parse(userToken);
                    // this.regionService.searchGetRegionsByPartyId(objUser.user.PERSON.PARTy.ID);
                    this.store.dispatch(tokenLogin({ userToken: JSON.parse(userToken) }));

                    console.log('NAVIGATION: checking feature entity');
                    console.log(this.bDisableFeatureCheck);
                }
            } else {
                if (this.sidenav) {
                    this.sidenav.close();
                }
                this.showWholeMenu = false;
            }
        });

        //Refresh Counts
        this.workflowsService.refresh$.subscribe(() => {
            this.getworkbenchCounts();
        });
    }

    ngOnDestroy() {}

    loadDashboardViaMsinLogo() {
        console.log('calling loadDashboardViaMsinLogo');
        var timedOutTime = new Date();
        ///   this.router.navigateByUrl(`/dashboard/${true}`);  // stayOnPage activated
    }

    getBackupDataObservable() {
        console.log('getting getBackupDataResetSubject from navigation.component side');
        return this.getBackupDataSubject.asObservable();
    }

    subscribers() {
        this.authService.ping().subscribe((res) => {
            console.log('pinged');
            console.log(res);
        });
    }

    performLogout() {
        this.showWholeMenu = false;
        this.isUILoggedOut = true;
        if (this.sidenav) {
            this.sidenav.close();
        }

        this.store.dispatch(AuthActions.logout());
    }

    getworkbenchCounts() {
        this.getInboxNodesCount();
        this.getInProgressNodesCount();
        this.getOutboxNodesCount();
    }

    getInboxNodesCount() {
        this.loading = true;
        this.workflowsService.getInboxNodesCount().subscribe({
            next: (res) => {
                if (res?.count) {
                    this.inboxNodesCount = JSON.parse(res.count);
                }
            },
            complete: () => {
                this.loading = false;
            }
        });
    }

    getInProgressNodesCount() {
        this.loading = true;
        this.workflowsService.getInProgressNodesCount().subscribe({
            next: (res) => {
                if (res?.count) {
                    this.inProgressNodesCount = JSON.parse(res.count);
                }
            },
            complete: () => {
                this.loading = false;
            }
        });
    }

    getOutboxNodesCount() {
        this.loading = true;
        this.workflowsService.getOutboxNodesCount().subscribe({
            next: (res) => {
                if (res?.count) {
                    this.outboxNodesCount = JSON.parse(res.count);
                }
            },
            complete: () => {
                this.loading = false;
            }
        });
    }
}
